namespace SolovisGateway.Admin.DataEnvironments {

    export class EditDataEnvironmentEditorDialog {

        private _saveCallback;
        private _editDataEnvironmentEditor: EditDataEnvironmentEditorControl;
        private _dialogWindow: Solovis.UI.Dialog;

        constructor(options) {
            var self = this;

            var dataEnvironmentId = options.dataEnvironmentId ? options.dataEnvironmentId : null;

            var desiredWidth = Math.min($(window).width() * .8, 800);
            var desiredHeight = Math.min($(window).height() * .8, 800);

            var minWidth = 100;
            var minHeight = 100;

            this._saveCallback = options.saveCallback ? options.saveCallback : null;

            var editorDiv = $("<div>")
                .css("min-height", "75px");

            this._editDataEnvironmentEditor = new SolovisGateway.Admin.DataEnvironments.EditDataEnvironmentEditorControl({
                controlHost: editorDiv,
                dataEnvironmentId: dataEnvironmentId
            });

            this._editDataEnvironmentEditor.setAsCurrentControl();

            this._dialogWindow = new Solovis.UI.Dialog({
                container: editorDiv,

                title: "Edit Data Environment",

                modal: true,
                center: true,
                actions: ["Close"],
                autoOpen: true,
                destroyOnClose: true,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,
                buttons: [
                    {
                        label: "Save",
                        click: function () {
                            self._save();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._dialogWindow.close();
                        }
                    }
                ]
            });
        }


        public _cancel() {
            this._dialogWindow.close();
        }

        public _save() {
            var self = this;

            if (this._editDataEnvironmentEditor.isValid()) {

                var model = this._editDataEnvironmentEditor._getEditDataEnvironmentModel();

                Solovis.Rpc.invokeAndWait("~/Admin/DataEnvironmentAdmin/SetDataEnvironment",
                    {
                        model: model
                    },
                    function (response, success) {
                        if (success) {
                            if (response.result.modelIsValid) {
                                var savedDataEnvironmentEditorModel = response.result.modelResult;
                                self._editDataEnvironmentEditor._savedDataEnvironmentEditorModel = savedDataEnvironmentEditorModel;
                                if (self._saveCallback) {
                                    self._saveCallback();
                                }
                                self._dialogWindow.close();
                            }
                            else {
                                self._editDataEnvironmentEditor._formBuilder.applyErrors(response.result.errors);
                            }
                        }
                    });
            }
        }

        public static showDialog(options) {
            var dialog = new SolovisGateway.Admin.DataEnvironments.EditDataEnvironmentEditorDialog(options);
        }
    }

}
